import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from "react";
import { useFormContext } from "react-hook-form";
import { HexColorPicker } from "react-colorful";
import TextField from "./TextField";
import FAIcon from "../UI/FAIcon/FAIcon";
const ColorField = ({ name, label, helpText, required, }) => {
    const { setValue, watch } = useFormContext();
    const pickerRef = useRef(null);
    const [showPicker, setShowPicker] = useState(false);
    const handleColorChange = (colorCode) => {
        setValue(name, colorCode);
    };
    const color = watch(name);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (pickerRef.current &&
                !pickerRef.current.contains(event.target)) {
                setShowPicker(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    return (_jsxs("div", { ref: pickerRef, className: "mb-3 position-relative", children: [_jsx(TextField, { name: name, label: label, helpText: helpText, append: _jsxs(_Fragment, { children: [_jsx("button", { className: "btn border-top border-bottom", style: { backgroundColor: color || "transparent", width: 30 }, onClick: () => setShowPicker(!showPicker), children: " " }), _jsx("button", { className: "btn btn-outline-control", onClick: () => setShowPicker(!showPicker), children: _jsx(FAIcon, { icon: "swatchbook" }) })] }), required: required, pattern: {
                    value: /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/,
                    message: "Must be a valid hex color like #000000",
                } }), showPicker && (_jsx(HexColorPicker, { style: {
                    top: "80%",
                    left: "10%",
                }, className: "position-absolute popover", color: color, onChange: handleColorChange }))] }));
};
export default ColorField;
